import classNames from 'classnames/bind';
import ModalV2, { MODAL_TYPES } from 'components/Modal/ModalV2/ModalV2';
import PropTypes from 'prop-types';
import styles from './GoogleMapMobile.module.css';

const cx = classNames.bind(styles);

/**
 * Stated here rather than left to the `propTypes` block below, which is what the
 * JSX checker would otherwise use: `PropTypes.node.isRequired` resolves to
 * prop-types' `NonNullable<ReactNodeLike>`, and a JSX element is not assignable
 * to it — so passing an element as `children` was an error.
 *
 * @param {{ children?: import('react').ReactNode, onHide?: () => void,
 *   visible?: boolean, defaultHeader?: boolean }} props
 */
export const GoogleMapMobile = ({
  children,
  onHide,
  visible,
  defaultHeader,
}) => {
  return visible ? (
    <ModalV2
      noPadding
      onHide={onHide}
      show={visible}
      type={MODAL_TYPES.FULL_PAGE}
      defaultHeader={defaultHeader}
    >
      <div className={cx('full-height')}>{children}</div>
    </ModalV2>
  ) : null;
};

GoogleMapMobile.propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  defaultHeader: PropTypes.bool,
};

GoogleMapMobile.defaultProps = {
  onHide: null,
};
